<template>
  <!-- Modal -->
  <div>
    <form-text ref="name" label="Name" name="input" v-model="input.name" validation="required"></form-text>
    <form-select ref="type" label = "Type" name="type" v-model="input.type" :options="inputTypes" validation="required"></form-select>
  </div>
</template>

<script>
import FormText from '../../../elements/Form/FormText'
import FormSelect from '../../../elements/Form/FormSelect'


export default {
  components:{
    'form-text': FormText,
    'form-select': FormSelect
  },
  data() {
    return {
      input: {
        name: '',
        type: 'number'
      },
      inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}]
    }
  }
}
</script>


// WEBPACK FOOTER //
// Input.vue?0719e802